export const getJoyrideSteps = (Username, arearange) => {
  const isMobile = window.innerWidth < 940;
  const area = arearange == 'A';
  return [
    {
      target: isMobile ? '.my-first-step' : '.my-first-steps',
      content: `Welcome, ${Username}! Let's take a quick tour.`,
      disableBeacon: true,
      placement: isMobile ? 'bottom-start' : 'top',
    },
    {
      target: isMobile ? '#drawer' : '#profile',
      content: isMobile
        ? 'Navigate Here to update your Profile details'
        : 'This is your profile. Tap to update your personal details.',
      placement: isMobile ? 'bottom' : 'right',
      disableBeacon: true,
    },
    {
      target: '#expensedashboard',
      content: "Here you'll see your total expenses for the current month.",
      disableBeacon: true,
    },
    {
      target: '#sfc',
      content: 'Add or submit your Standard Fare Charts (SFC) here.',
      disableBeacon: true,
    },
    {
      target: '#expense',
      content: 'View your expense details and submit them for approval.',
      disableBeacon: true,
    },
    {
      target: '#unreported',
      content: 'Attach and manage your unreported bills here.',
      disableBeacon: true,
    },
    {
      target: '#pending',
      content: 'Track your pending tasks here.',
      disableBeacon: true,
    },
    {
      target: isMobile ? '#camera img' : '#Uploads',
      content: 'Upload your bills here.',
      disableBeacon: true,
      placement: 'bottom',
      disableScrolling: true,
    },
    ...(area
      ? !isMobile
        ? [
            {
              target: arearange ? '#stpfc' : '',
              content: 'Approve or reject STPFC requests here.',
            },
            {
              target: arearange ? '#expenses' : '',
              content: 'Approve or reject Expense requests here.',
            },
          ]
        : []
      : []),
  ];
};
